<i18n>
{
  "en": {
    "language": "English"
  },
  "th": {
    "language": "ภาษาไทย"
  }
}
</i18n>
<template>
  <div style="max-width: 128px; max-height: 50px">
    <v-select
      :items="languagePack"
      :label="languageText"
      solo
      @change="changeLanguage"
    />
  </div>
</template>

<script>
export default {
  name: 'PaowLanguageSelector',
  data () {
    return {
      languagePack: ['English', 'ภาษาไทย']
    }
  },
  methods: {
    changeLanguage (event) {
      if (event === 'ภาษาไทย') {
        this.$root.$i18n.locale = 'th'
        localStorage.setItem('layoutLanguage', 'th')
      } else {
        this.$root.$i18n.locale = 'en'
        localStorage.setItem('layoutLanguage', 'en')
      }
    }
  },
  computed: {
    languageText () {
      return this.$t('language')
    }
  },
  created () {
    let language = localStorage.getItem('layoutLanguage')
    if (!language) {
      this.$root.$i18n.locale = navigator.language.substring(0, 2)
    } else {
      this.$root.$i18n.locale = language
    }
  }
}
</script>

<style scoped>
</style>
